/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2020, Zumper
 * @description Enum for apps that use the footer and serve pages linked to by the footer
 */

export enum App {
  MANAGE = 'MANAGE',
  NZR = 'NZR',
}
